import "../src/global/global-pc"
import "../src/stars/StarsSubscription"
import {
    addEventListenersToMyStarsFilterButtons,
    setNavigationCookieEventListeners,
} from "../src/stars/my-stars/my-stars.ts"

import "@modules/stars/styles-pc.css"
import "@modules/stars/not-logged-in-box.css"
import "@modules/stars/my-stars/pc.css"
import "@modules/vue-modals/age-verification.js"
import "@modules/vue-modals/coins"

addEventListenersToMyStarsFilterButtons()
setNavigationCookieEventListeners()
